import { Action, ActionReducer, combineReducers } from '@ngrx/store';
import { ToolsView } from '../../../_generated';
import { RequestStatus } from '../../actionstypes/request-status/request-status.actiontype';
import { ToolsRequestStatusAction } from '../../actionstypes/tools/tools-request-status.actiontype';
import requestStatusReducer from '../request-status/request-status.reducer';
import toolsReducer from './tools.reducer';

export interface RootTools {
  requestStatus: RequestStatus;
  data: ToolsView[];
}

export const toolsRootReducer = combineReducers({
  requestStatus: requestStatusReducer(ToolsRequestStatusAction.Load, ToolsRequestStatusAction.Success, ToolsRequestStatusAction.Error),
  data: toolsReducer as ActionReducer<ToolsView[], Action<string>>,
});
